
/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface ValidateEmailRequest {
    code: string;
}

/**
 * 
 */
export class AccountVerificationApi extends runtime.BaseAPI {

    /**
     * Send a new code for email validation (outside of signup workflow)
          */
    async sendEmailValidationCodeRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/signup-client/api/send-email-validation-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Send a new code for email validation (outside of signup workflow)
          */
    async sendEmailValidationCode(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.sendEmailValidationCodeRaw(initOverrides);
    }

    /**
     * Validate an email by code (outside of signup workflow)
          */
    async validateEmailRaw(requestParameters: ValidateEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling validateEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/signup-client/api/validate-email/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Validate an email by code (outside of signup workflow)
          */
    async validateEmail(requestParameters: ValidateEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.validateEmailRaw(requestParameters, initOverrides);
    }

}
